<template>
  <div id="dashboard-page">
    <div class="dashboard-page-wrapper" :class="{ 'hidden': showDownloadPopup }">
      <h1>Data Centre</h1>
      <dashboard-card-container
        :value="companySections"
        @download="getDownloadAllFile"
      />
    </div>
    <download-all
        v-if="showDownloadPopup"
        :downloading="downloadingAll"
        :success="downloadAllSuccess"
        :download-file="downloadFile"
        @downloadAll="downloadAll"
        @closeDownloadAllModal="closeDownloadAllModal"
    />
  </div>
</template>

<script>
import DashboardCardContainer from './DashboardCardContainer.vue'
import { formMap } from './SectionsConfig'
import DownloadAll from './DownloadAll';
import FileDownloadMixin from "../../../components/mixins/FileDownloadMixin";

export default {
  name: "DashboardGrid",
  components: {
    DashboardCardContainer,
    DownloadAll,
  },
  mixins: [FileDownloadMixin],
  data() {
    return {
      showDownloadPopup: false,
      downloadingAll: false,
      downloadAllSuccess: false,
      downloadFile: {},
    };
  },
  computed: {
    privileges() {
      return this.$store.getters['personas/privileges'];
    },
    companySections() {
      // Access privileges so Vue tracks it as a reactive dependency
      this.privileges;
      return formMap();
    },
  },
  created() {
    this.$store.dispatch('personas/fetchPersonaPrivileges');
  },
  methods: {
    closeDownloadAllModal() {
      this.showDownloadPopup = false;
      this.downloadingAll = false;
      this.downloadAllSuccess = false;
      this.downloadFile = {};
    },
  },
}
</script>
